export const LinkCircles = [
    {
        index:0,
        x: -4.5, 
        y: -6.3, 
        size: 16.2, 
        color: 1, 
        textColor1: 2,
        textColor2: 0,
        title: '來點演講',
        subTitle: 'WATCH',
        to: '/conference'
    },
    {
        index:1,
        x: 5,
        y: -2.7, 
        size: 15,
        color: 2,
        textColor1: 1,
        textColor2: 0,
        title: '關於我們',
        subTitle: 'ABOUT',
        to: '/crew'
    },
    {
        index:2,
        x: -4,
        y: 0, 
        size: 13.5,
        color: 0,
        textColor1: 1,
        textColor2: 2,
        title: '購票',
        subTitle: 'TICKETS',
        to: '/ticket'
    },
]

export const DecorationCircles = [

    {
        index:3,
        x: 0,
        y: -10, 
        size: 4,
        color: 2
    },
    
    {
        index:4,
        x: 9.5,
        y: -6, 
        size: 4.5,
        color: 0
    },
    {
        index:5,
        x: 5,
        y: -8, 
        size: 10,
        color: 0 
    },
    {
        index:6,
        x: 2,
        y: 3, 
        size: 8,
        color: 1
    },
    {
        index:7,
        x: -2.5,
        y: 5, 
        size: 6.5,
        color: 2
    },
    {
        index:8,
        x: 0,
        y: 6.5, 
        size: 3,
        color: 2
    },
    {
        index:9,
        x: 3,
        y: 6, 
        size: 4,
        color: 0
    },
    {
        index:10,
        x: 6.2,
        y: 1.2, 
        size: 3.5,
        color: 0
    },
    {
        index:11,
        x: -8.5,
        y: -2.8, 
        size: 3.5,
        color: 1
    },
    {
        index:12,
        x: -3.1,
        y: 3.2, 
        size: 1,
        color: 1
    },
    {
        index:13,
        x: 1.7,
        y: 0.6, 
        size: 2.8,
        color: 1
    },
    {
        index:14,
        x: 2.3,
        y: -10, 
        size: 2,
        color: 1
    },
    {
        index:15,
        x: -9.6,
        y: -4, 
        size: 2,
        color: 2
    },
    {
        index:16,
        x: 1.9,
        y: -6, 
        size: 2.3,
        color: 0
    },
    {
        index:17,
        x: 1.1,
        y: 5.3, 
        size: 1.9,
        color: 1
    },
    {
        index:18,
        x: 5.5,
        y: 2.5, 
        size: 2.2,
        color: 1
    },
    {
        index:19,
        x: -1.1,
        y: -3, 
        size: 2.5,
        color: 2
    },
    {
        index:20,
        x: 9.2,
        y: -7.5, 
        size: 2,
        color: 1
    },
    {
        index:21,
        x: -1.7,
        y: 3.1, 
        size: 2.5,
        color: 0
    },
    {
        index:22,
        x: -2.3,
        y: -10, 
        size: 2,
        color: 0
    },
    {
        index:23,
        x: -3.4,
        y: 6.7, 
        size: 1,
        color: 0
    },
    {
        index:24,
        x: 4,
        y: 4.7, 
        size: 1.7,
        color: 2
    },

    {
        index:25,
        x: 10,
        y: -4.5, 
        size: 1.2,
        color: 2
    },

    {
        index:26,
        x: 0.8,
        y: -8.7, 
        size: 1.8,
        color: 1
    },

    {
        index:27,
        x: -10,
        y: -4.8, 
        size: 1,
        color: 0
    },
    {
        index:28,
        x: 3.8,
        y: 1, 
        size: 2.2,
        color: 2
    },
    
    {
        index:29,
        x: -4.5,
        y: 3.5, 
        size: 2.6,
        color: 2
    },
]


export const DecorationBase = [
    {
        index:0,
        x: 0, 
        y: 8.9, 
        width: 8, 
        height: 13,
        color1: 2,

    },

    {
        index:2,
        x: 0,
        y: 9.9, 
        width: 10,
        height: 13,
        color1: 0,
    }
]